export const titles = {
  default: 'Neues Passwort wählen',
  error: 'Änderung fehlgeschlagen',
  success: 'Passwort geändert',
};

export const descriptions = {
  default: 'Wähle bitte dein neues Passwort und bestätige es, um dein Konto zu aktualisieren.',
  pending: 'Bitte habe einen Moment Geduld, während wir dein Passwort aktualisieren.',
  error:
    'Beim Ändern deines Passworts ist ein Fehler aufgetreten. Möglicherweise ist der Link zum Zurücksetzen deines Passworts abgelaufen, da er nur 10 Minuten gültig ist. Bitte fordere einen neuen Link an und versuche es erneut. Sollte der Fehler weiterhin auftreten, kontaktiere bitte unseren Support.',
  success:
    'Dein Passwort wurde erfolgreich geändert. Du kannst dich nun mit deinem neuen Passwort anmelden.',
};
